import { tableColumnTypes } from "../../tableColumnTypes";
import { formatDate } from "./distributionHistory";

export let seriesHistory = {
  name: "Series History",
  columns: () => [
    {
      ID: 1,
      name: "Who",
      fieldName: "DistributedBy",
      value: (row) => row.DistributedBy,
      sort: false,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: "When",
      fieldName: "DistributedDate",
      value: (row) => formatDate(row.DistributedDate),
      sort: false,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 3,
      name: "Whom",
      fieldName: "Category",
      value: (row) => row.Category,
      sort: false,
      type: tableColumnTypes.STRING,
    },
  ],
};
